<template>
  <div class="yuyueguahao">
    <van-cell-group inset style="margin-top:20px;">
      <van-cell title="按科室挂号" value="" size="large" label="查看详情" center is-link @click="toKeShi">
        <!-- <i slot="icon" class="icon-a-8 cell-left-icon iconfont"></i> -->
        <template #icon>
          <div class="img"><img src="../../assets/images/keshi_icon.png" alt=""></div>
        </template>
      </van-cell>
    </van-cell-group>
    <van-cell-group inset style="margin-top:20px;">
      <van-cell title="按医生挂号" value="" size="large" label="查看详情" center is-link @click="goTo">
        <!-- <i slot="icon" class="icon-jiuzhenren cell-left-icon iconfont"></i> -->
        <template #icon>
          <div class="img"><img src="../../assets/images/doctor_icon.png" alt=""></div>
        </template>
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
import mixin from '../../mixins'
export default {
  name: 'GuaHaoFangShi',
  mixins: [mixin],
  data() {
    return {
      type: 1
    }
  },
  created() {
    this.type = this.$route.query.type || 1
  },
  mounted() {

  },
  methods: {
    toKeShi() {
      this.$router.push(`/yuyueguahao?type=${this.type}`)
    },
    goTo() {
      this.$router.push(`/xuanzeyisheng?type=${this.type}`)
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
// .cell-left-icon {
//     font-size: 40px;
//     margin-right: 10px;
//     color: #1677ff;
//   }
  .img{
    width: 38px;
    height: 38px;
    padding-right:16px;
    img{
       width: 38px;
    height: 38px;
    }
  }
</style>
